import React from 'react';
import MetricCard from './MetricCard';

const Section = React.memo(function Section({ title, metrics }) {
  return (
    <div className="metrics-section">
      <div className="metrics-section-title">{title}</div>
      <div className="metrics-section-cards">
        {metrics.map((m, i) => <MetricCard key={i} {...m} />)}
      </div>
    </div>
  );
});

export default Section; 